import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { Row, Col, Layout, Button } from 'antd';
import Animate from 'rc-animate';
import { SwapOutlined } from '@ant-design/icons';

import WithIndicator from 'common/components/wrapper/WithIndicator';

import { LoginForm } from './components';

import userSelector from '@redux/user/selectors';
import * as userActions from '@redux/user/actions';
import * as brandingSelectors from '@redux/branding/selectors';

import { isAuthed } from 'utils/common/session';

import { getParameterFromQuery } from 'utils/common/route';

import { sleep } from 'utils/delay';

import IntroductionImage from 'assets/login-product-hub.jpg';

import './style.less';
import { WithLoading } from 'common/components';
const loginTypeDefine = ['daymon', 'productHub'];
const loginTypeDefault = loginTypeDefine?.[0];

/**
 * Main login page
 */
const LogIn = ({ from, isHaveLoginSwitch = false }) => {
  const [loginType, setLoginType] = useState(loginTypeDefault);
  const [switchLoading, setSwitchLoading] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();

  // selectors
  const loading = useSelector(userSelector.selectUserLoading());
  const error = useSelector(userSelector.selectUserError());
  const branding = useSelector(brandingSelectors.getBranding());

  /**
   * Go to register page
   */
  function toSignIn() {
    dispatch(userActions.reset());
    history.push('register');
  }

  /**
   * display login action with username/password
   * @param {object} values login information
   */
  const onFinish = (values) => {
    dispatch(userActions.login(values));
  };

  const toSwitchLoginType = async () => {
    setSwitchLoading(true);
    if (loginType === 'rivir') {
      setLoginType('daymon');
    } else {
      setLoginType('rivir');
    }
    await sleep(1400);
    setSwitchLoading(false);
  };

  useEffect(() => {
    // check if user is in session, redirect to '/waiting'
    if (isAuthed()) {
      const returnUrl = getParameterFromQuery('returnUrl') || '/';
      history.push(`/waiting?returnUrl=${returnUrl}`);
    }
  }, []);

  return (
    <Layout className='login'>
      <WithLoading loading={loading}>
        <Animate component='' transitionAppear transitionName='fade'>
          <Row
            justify='end'
            align='middle'
            style={{
              minHeight: '100vh',
              backgroundImage: `url(${IntroductionImage})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            }}
            className='login'
          >
            <Col style={{ width: 600 }}>
              <Row
                justify='center'
                align='middle'
                style={{
                  height: '100%',
                }}
              >
                <Col flex='auto'>
                  {isHaveLoginSwitch && (
                    <Button
                      className='login__btn-switch-type'
                      onClick={toSwitchLoginType}
                      type='primary'
                      loading={switchLoading}
                      icon={<SwapOutlined />}
                    />
                  )}
                  <WithIndicator
                    component={LoginForm}
                    onFinish={onFinish}
                    error={error}
                    branding={branding}
                    usercls='login__form'
                    loginType={loginType}
                    isHaveLoginSwitch={isHaveLoginSwitch}
                    switchLoading={switchLoading}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Animate>
      </WithLoading>
    </Layout>
  );
};

export default LogIn;
